import type {ExportEnv} from './types'

export * from './index.browser'

/** @public */
export const environment = 'react-server' satisfies ExportEnv
